module.exports = __webpack_public_path__ + "static/covid-2-33a7e5cc9e7d2463dfeffe30078026ae.png";